import { Injectable } from '@angular/core'
import { environment } from '../../../../../environments/environment'
import { HttpClient } from '@angular/common/http'
import { Observable } from 'rxjs'
import { ResponseRequestModel } from '../../../models/response.model'
import {
  CreateLegalEntityClientModel,
  DeleteLegalEntityClientModel,
  SearchLegalEntityClientModel,
} from '../../../models/medic.model'

@Injectable({
  providedIn: 'root',
})
export class MedicService {
  private baseUrl = environment.baseUrl
  private resource: string = 'tutorlocal'

  constructor(private httpClient: HttpClient) {}

  public createMedico(
    model: any,
    // model: CreateLegalEntityClientModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/create`,
      model,
    )
  }

  public editMedico(
    model: any,
    // model: EditLegalEntityClientModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.put<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/update`,
      model,
    )
  }

  public deleteLegalEntityClient(
    model: DeleteLegalEntityClientModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/delete`,
      model,
    )
  }

  public listPagedMedic(
    page: number,
    rows: number = 10,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/paginado?page=${page}&per_page=${rows}`,
    )
  }

  public listPagedLegalEntityClientBySubClientId(
    subClientId: number,
    page: number,
    rows: number = 15,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/listpaginated/associado-subcliente/${subClientId}?pageNumber=${page}&pageSize=${rows}`,
    )
  }

  public listPagedNotLegalEntityClientBySubClientId(
    subClientId: number,
    page: number,
    rows: number = 15,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/listpaginated/desassociado-subcliente/${subClientId}?pageNumber=${page}&pageSize=${rows}`,
    )
  }

  public listMedic(): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/list`,
    )
  }

  public getLegalEntityClientbyId(
    id: number,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/${id}`,
    )
  }

  public searchPagedMedic(
    page: number,
    rows: number = 10,
    model: SearchLegalEntityClientModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/paginado?page=${page}&per_page=${rows}&nome=${model.nome_principal}&crm=${model.crm}`,
    )
  }

  public searchPagedLegalEntityClientAssociateBySubClient(
    page: number,
    rows: number = 15,
    model: SearchLegalEntityClientModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/search-paginated/associado-subcliente?pageNumber=${page}&pageSize=${rows}`,
      model,
    )
  }
}
